import Model from 'flarum/common/Model';

export default class CourseArticle extends Model {}

Object.assign(CourseArticle.prototype, {
  levelCode: Model.attribute('level_code'),
  moduleCode: Model.attribute('module_code'),
  title: Model.attribute('title'),
  content: Model.attribute('content'),
  sortOrder: Model.attribute('sort_order'),
  status: Model.attribute('status'),
  hasAssignment: Model.attribute('has_assignment'),
  assignmentPrompt: Model.attribute('assignment_prompt'),
  hasQuiz: Model.attribute('has_quiz'),
  swordThreshold: Model.attribute('sword_threshold'),
  swordReward: Model.attribute('sword_reward'),
  difyKnowledgeBaseId: Model.attribute('dify_knowledge_base_id'),
  aiAnswerKey: Model.attribute('ai_answer_key'),
  isActive: Model.attribute('is_active'),
  createdAt: Model.attribute('created_at', Model.transformDate),
  updatedAt: Model.attribute('updated_at', Model.transformDate),

  level: Model.hasOne('level'),
  module: Model.hasOne('module'),
  quizQuestions: Model.hasMany('quizQuestions'),
});
